//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getCompanyList } from '@/api/baseDate';
import { exchange, exchange_queryPage, getExcelPath, download, exchange_import, saveExchange, deleteExchange } from '@/api/baseDataManage';
export default {
  name: 'rateImport',
  data: function data() {
    return {
      fileList: [],
      loading: false,
      currencys: [],
      //币种下拉
      company: '',
      //保险公司
      companyList: [],
      //获取保险公司列表并匹配
      // 查询条件
      form: {
        insuranceCompanyCode: '',
        currencyName: '',
        pageNo: 1,
        pageSize: 10,
        currency: '',
        startDate: '',
        endDate: ''
      },
      total: 0,
      //数据条数
      tableData: [],
      screenLoading: null,
      newumarBtn: false,
      new_edit: false,
      editData: {},
      markForm: {
        tbcExchangeRateId: '',
        type: '',
        currency: '',
        currencyName: '',
        excurrency: '',
        excurrencyName: '',
        exchangeRate: '',
        startDate: '',
        endDate: ''
      },
      markForm_new: {
        tbcExchangeRateId: '',
        type: '',
        currency: '',
        currencyName: '',
        excurrency: '',
        excurrencyName: '',
        exchangeRate: '',
        startDate: '',
        endDate: ''
      },
      exchangerule: {
        currency: [{
          required: true,
          message: '请输入原币种',
          trigger: 'blur'
        }],
        currencyName: [{
          required: true,
          message: '请输入币种名称',
          trigger: 'blur'
        }],
        excurrency: [{
          required: true,
          message: '请输入兑换币种',
          trigger: 'blur'
        }],
        excurrencyName: [{
          required: true,
          message: '请输入兑换币种名称',
          trigger: 'blur'
        }],
        exchangeRate: [{
          required: true,
          message: '请输入汇率',
          trigger: 'blur'
        }],
        startDate: [{
          required: true,
          message: '请输入起始时间',
          trigger: 'blur'
        }],
        endDate: [{
          required: true,
          message: '请输入终止时间',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    getCompanyList().then(function (res) {
      _this.companyList = Object.assign([], res); // this.company = this.form.insuranceCompanyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode

      _this.company = _this.form.insuranceCompanyCode = JSON.parse(sessionStorage.getItem('newinsurancecompanyCode'));

      _this.getData();

      exchange({
        insuranceCompanyCode: _this.form.insuranceCompanyCode || ''
      }).then(function (data) {
        _this.currencys = data;
      });
    });
  },
  methods: {
    //   查询
    submitForm: function submitForm(formName) {
      this.form.pageNo = 1;

      if (this.form.startDate && this.form.endDate) {
        if (this.form.startDate > this.form.endDate) {
          this.$message({
            type: 'warning',
            message: '起始日期不能晚于终止止期'
          });
          return false;
        }
      }

      this.getData();
    },
    // 获取数据
    getData: function getData() {
      var _this2 = this;

      this.loading = true;
      exchange_queryPage(this.form).then(function (res) {
        _this2.loading = false;
        _this2.tableData = res.content;
        _this2.total = res.totalCount;
      });
    },
    //   重置查询条件
    resetForm: function resetForm(formName) {
      this.form.currency = this.form.currencyName = '';
      this.form.startDate = '';
      this.form.endDate = '';
      this.getData();
    },
    // 分页方法
    handleSizeChange: function handleSizeChange(val) {
      this.form.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.pageNo = val;
      this.getData();
    },
    //编辑/新增保存
    editSave: function editSave(formName, type) {
      var _this3 = this;

      var data = type == 'edit' ? this.markForm : this.markForm_new;

      if (type == 'edit') {
        this.markForm.type = '1';
      } else {
        this.markForm_new.type = '0';
      }

      if (this.markForm.startDate && this.markForm.endDate) {
        if (this.markForm.startDate > this.markForm.endDate) {
          this.$message({
            type: 'warning',
            message: '起始日期不能晚于终止止期'
          });
          return false;
        }
      }

      if (this.markForm_new.startDate && this.markForm_new.endDate) {
        if (this.markForm_new.startDate > this.markForm_new.endDate) {
          this.$message({
            type: 'warning',
            message: '起始日期不能晚于终止止期'
          });
          return false;
        }
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.new_edit = _this3.newumarBtn = false;

          _this3.openFullScreen();

          saveExchange(data).then(function (res) {
            // console.log(res)
            if (res.resultCode == '0000') {
              _this3.$message({
                message: '保存成功',
                type: 'success'
              });

              for (var key in _this3.markForm_new) {
                _this3.markForm_new[key] = '';
              }

              _this3.getData();
            } else {
              _this3.$message({
                message: res.resultMsg,
                type: 'warning'
              });
            }

            _this3.screenLoading.close();

            _this3.markForm_new = {
              tbcExchangeRateId: '',
              type: '',
              currency: '',
              currencyName: '',
              excurrency: '',
              excurrencyName: '',
              exchangeRate: ''
            };
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 编辑
    edit: function edit(data) {
      this.editData = data;
      this.new_edit = true;

      for (var key in this.markForm) {
        this.markForm[key] = data[key];
      }
    },
    // 删除
    dele: function dele(data) {
      var _this4 = this;

      console.log(data);
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteExchange({
          tbcExchangeRateId: data.tbcExchangeRateId
        }).then(function (res) {
          // console.log(res)
          if (res.resultCode == '0000') {
            _this4.$message({
              type: 'success',
              message: '删除成功!'
            });

            _this4.getData();
          } else {
            _this4.$message({
              type: 'warning',
              message: res.resultMsg
            });
          }
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 取消
    selectcancel: function selectcancel(formname, type) {
      var _this5 = this;

      if (type == 'new') {
        this.newumarBtn = false;
      } else {
        this.new_edit = false;
      }

      this.$nextTick(function () {
        _this5.$refs[formname].clearValidate();
      });
    },
    // 获取下载链接
    getExecl: function getExecl() {
      getExcelPath({
        fileDownloadType: 'changeRate'
      }).then(function (res) {
        if (res.rtnCode == '0000') {
          // 获取下载文件
          download({
            fileSrc: res.fileSrc
          }).then(function (res2) {
            var blob = new Blob([res2], {
              type: "application/vnd.ms-excel"
            }); // 兼容ie

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, "汇率清单模板.xlsx");
            } else {
              var url = window.URL.createObjectURL(blob);
              var link = document.createElement("a"); // 创建a标签

              link.href = url;
              link.download = "汇率清单模板.xlsx"; // 重命名文件

              link.click();
              window.URL.revokeObjectURL(url); // 释放内存
            }
          });
        }
      });
    },
    openFullScreen2: function openFullScreen2() {
      this.screenLoading = this.$loading({
        lock: true,
        text: '导入中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    openFullScreen: function openFullScreen() {
      this.screenLoading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    // 上传
    importExcel: function importExcel(file) {
      var _this6 = this;

      var extension = file.file.name.substring(file.file.name.lastIndexOf('.') + 1);

      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message.warning('只能上传后缀是.xlsx或者.xls的文件');
        return;
      }

      var dataFile = new FormData();
      dataFile.append('file', file.file);
      this.openFullScreen2();
      exchange_import(dataFile).then(function (res) {
        _this6.screenLoading.close();

        if (res.resultCode == '0000') {
          _this6.$message({
            type: 'success',
            message: '导入成功'
          });

          _this6.getData();
        } else {
          _this6.$message({
            type: 'warning',
            message: res.resultMsg
          });
        }
      });
    }
  }
};